// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fs-navigation-base {
  font-family: var(--font-navigation);
  font-weight: var(--font-navigation-weight);
  font-style: var(--font-navigation-style);
}

.drawer-menu__link .disclosure__toggle .icon {
  width: 8px !important;
  height: 8px !important;
  display: flex;
  align-items: center;
  margin-top: 1px;
  margin-left: 6px;
  margin-left: calc(var(--spacing-2) - 2px);
}
.drawer-menu__link .disclosure-form__item #lang-list-drawer {
  padding: 12px;
  padding: var(--spacing-3);
}
.drawer-menu__link .disclosure-form__item .disclosure-list__option > .icon {
  display: flex;
  width: 14px;
  height: 14px;
  margin-left: auto;
  margin-right: 0;
  color: var(--color-text);
}`, "",{"version":3,"sources":["webpack://./src/Common/components/shared.bundle/styles/navigation.scss"],"names":[],"mappings":"AAAA;EACE,mCAAA;EACA,0CAAA;EACA,wCAAA;AACF;;AAII;EACE,qBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,yCAAA;AADN;AAMI;EACE,aAAA;EACA,yBAAA;AAJN;AAOI;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,wBAAA;AALN","sourcesContent":[".fs-navigation-base {\n  font-family: var(--font-navigation);\n  font-weight: var(--font-navigation-weight);\n  font-style: var(--font-navigation-style);\n}\n\n.drawer-menu__link {\n  .disclosure__toggle {\n    .icon {\n      width: 8px !important;\n      height: 8px !important;\n      display: flex;\n      align-items: center;\n      margin-top: 1px;\n      margin-left: calc(calc(4px * 2) - 2px);\n      margin-left: calc(var(--spacing-2) - 2px);\n    }\n  }\n\n  .disclosure-form__item {\n    #lang-list-drawer {\n      padding: calc(4px * 3);\n      padding: var(--spacing-3);\n    }\n\n    .disclosure-list__option > .icon {\n      display: flex;\n      width: 14px;\n      height: 14px;\n      margin-left: auto;\n      margin-right: 0;\n      color: var(--color-text);\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
